import { LoadPageAction } from "../../../pillar/common/actions/LoadPageAction";
import { LoadPagePayload } from "../../../pillar/common/actions/LoadPagePayload";

export const GET_REPORTS_QUERY = "[Report] Get Reports Query";

export class GetReportsQueryAction implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_REPORTS_QUERY;

  constructor(public payload: LoadPagePayload) {}
}



// WEBPACK FOOTER //
// ./src/app/report/store/actions/GetReportsQueryAction.ts